import styled from '@emotion/styled';

import Accordion from '@mui/material/Accordion';
import Badge from '@mui/material/Badge';

export const StyledAccordion = styled(Accordion)`
  margin-bottom: 24px;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;

  &:before {
    display: none;
  }
`;

export const StyledBadge = styled(Badge)`
  & .MuiBadge-badge {
    transform: scale(1) translate(125%, 1px);
    background-color: ${(props) => props.badgeContent == 0 && '#c2c2c2'};
  }
`;
